import {Navigate, Route, Routes} from "react-router-dom";
import IndexCrf from "./CrfChecker";
import MaterialIndex from "./Material";
import VocabularyIndex from "./vocabulary";
import {PracticeAnalysisPage} from "./practice-analysis";

export default function ToolsIndex({className, ...props}) {

    return (
        <Routes>
            <Route path={"/cefr-checker"} element={<IndexCrf />}   />
            <Route path={"/material"} element={<MaterialIndex />}   />
            <Route path={"/vocabulary-list"} element={<VocabularyIndex />}   />
            <Route path={"/practice-analysis/:type"} element={<PracticeAnalysisPage />}   />
            <Route path={"/practice-analysis/*"} element={<Navigate to={"/tools/practice-analysis/Wap"} replace />}   />
        </Routes>

    )
}